// Remove a value from localStorage
export function removeSessionStorageItem(key) {
  sessionStorage.removeItem(key);
}
